
















import { defineComponent, PropType } from '@vue/composition-api';
import type { ImportedJobDetail } from './types';

export default defineComponent({
  props: {
    result: { type: Object as PropType<ImportedJobDetail['matrixTags']>, default: null },
    approved: { type: Boolean, default: false },
  },
});
